import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'LeagueTeam';

const LeagueTeamApi: any = baseApi(endpoint);


export default LeagueTeamApi;